import React, {useState} from "react";
import S from './ParticipationFormats.module.scss';
import { useDisclosure } from '@mantine/hooks';
import {ModalWindow} from "../modal";

interface IProps {
    event?: any;
}

export const ParticipationFormats = ({event}: IProps) => {
    const [opened, { open, close }] = useDisclosure(false);
    const [selectedTariff, setSelectedTariff] = useState<string>('');
    const handleOpenModal = (tariffType: string) => {
        setSelectedTariff(tariffType);
        open();
    };
    return (
        <div className={S.content}>
            <div className={S.contentDiv}>
                <div className={S.title}>ФОРМАТЫ УЧАСТИЯ</div>
                <div className={S.cardsDiv}>
                    <div className={S.cardDiv}>
                        <div className={S.textDiv}>
                            <div className={S.titleCard}>ОТРАСЛЕВЫЕ КОМПАНИИ</div>
                            <div className={S.textCard}>Профильные представители отраслевых компаний участвуют на
                                бесплатной основе.
                            </div>
                            <div className={S.paragraphDiv}>
                                <div className={event === 5 ? S.paragraphLogistics : S.paragraph}/>
                                <div className={S.paragraphText}>ФОРМАТ УЧАСТИЯ:</div>
                            </div>
                            <div className={S.traitDiv}>
                                <div className={S.paragraphDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.textCard}>Слушатель</div>
                                </div>
                                <div className={S.paragraphDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.textCard}>Спикер</div>
                                </div>
                                <div className={S.paragraphDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.textCard}>Модератор</div>
                                </div>
                            </div>
                            <div className={S.paragraphDiv}>
                                <div className={event === 5 ? S.paragraphLogistics : S.paragraph}/>
                                <div>
                                    <div className={S.paragraphText}>ВКЛЮЧАЕТ В СЕБЯ:</div>
                                </div>
                            </div>
                            <div className={S.textCardTwo}>участие в деловой программе<br/> форуме, кофе-брейки, обеды во<br/>
                                время проведения Форума.
                            </div>
                        </div>
                        <button className={event === 5 ? S.buttonLogistics : S.button} onClick={() => handleOpenModal("Отраслевые компании")}>ЗАРЕГИСТРИРОВАТЬСЯ</button>
                    </div>
                    <div className={S.cardDiv}>
                        <div className={S.textDiv}>
                            <div className={S.titleCard}>ПОСТАВЩИКИ РЕШЕНИЙ, ПО, УСЛУГ И ОБОРУДОВАНИЯ</div>
                            <div className={S.textCard}>
                                Коммерческие компании и подразделения, а также отраслевые компании (при потребности
                                анонсирования решений с целью дальнейшей коммерциализации ) — <span>на условиях
                                установленных тарифов.</span>
                            </div>
                            <div className={S.paragraphDiv}>
                                <div className={event === 5 ? S.paragraphLogistics : S.paragraph}/>
                                <div className={S.paragraphText}>ФОРМАТ УЧАСТИЯ:</div>
                            </div>
                            <div className={S.traitDiv}>
                                <div className={S.paragraphDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.textCard}>Партнер</div>
                                </div>
                                <div className={S.paragraphDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.textCard}>Делегат</div>
                                </div>
                                <div className={S.paragraphDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.textCard}>Спикер</div>
                                </div>
                                <div className={S.paragraphDiv}>
                                    <div className={S.trait}/>
                                    <div className={S.textCard}>Выставочный стенд</div>
                                </div>
                            </div>
                        </div>
                        <button
                            className={event === 5 ? S.buttonLogistics : S.button}
                            onClick={() => handleOpenModal("Поставщики решений, ПО, услуг и оборудования")}
                        >
                            ПОЛУЧИТЬ ТАРИФ
                        </button>
                    </div>
                    <div className={S.cardDiv}>
                    <div className={S.textDiv}>
                            <div className={S.titleCard}>ПАРТНЕРСКОЕ ВЗАИМОДЕЙСТВИЕ</div>
                            <div className={S.textCard}>(СМИ, Ассоциации, Комитеты и др.)</div>
                            <div className={S.textCard}><span>Мы будем рады обсудить детали партнерства и возможные форматы взаимодействия</span>
                            </div>
                        </div>
                        <button
                            className={event === 5 ? S.buttonLogistics : S.button}
                            onClick={() => handleOpenModal("Партнерское взаимодействие")}
                        >
                            ЗАРЕГИСТРИРОВАТЬСЯ
                        </button>
                    </div>
                </div>
            </div>
            <ModalWindow
                opened={opened}
                close={close}
                tariffType={selectedTariff}
                event={event}
            />
        </div>
    );
};